export default __webpack_public_path__ + "static/media/slider-arrow-right.2fae0db4.svg";